var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('list-table',{attrs:{"rules":_vm.rules,"readonly":_vm.readonly},on:{"delete-rule":_vm.deleteRule,"update-rule":_vm.updateRule}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }